<ng-container>{{claimStatuses[data[fieldName]]}}</ng-container>
